import { TRIPTYPE_SEE, TRIPTYPE_RIVER, TRIPTYPE_ORIENT } from "../../config";
export function getTripType(booking) {
    return booking?.["buchung/reiseart"] || null;
}
export function isOrient(booking) {
    return getTripType(booking) === TRIPTYPE_ORIENT;
}
export function isHighSea(booking) {
    return getTripType(booking) === TRIPTYPE_SEE;
}
export function isRiver(booking) {
    return getTripType(booking) === TRIPTYPE_RIVER;
}
